// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AppleOutlinedSvg from "@fishx/icons-svg/es/asn/AppleOutlined";
import FishxIcon from '../components/FishxIcon';

var AppleOutlined = function AppleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AppleOutlinedSvg
  }));
};

AppleOutlined.displayName = 'AppleOutlined';
export default React.forwardRef(AppleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AppleOutlined.js
// module id = 2006
// module chunks = 0